import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['MeasurementLog'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasurementLogById: build.query<GetMeasurementLogByIdApiResponse, GetMeasurementLogByIdApiArg>({
        query: (queryArg) => ({ url: `/MeasurementLog/${queryArg}` }),
        providesTags: ['MeasurementLog'],
      }),
      getMeasurementLogGetAll: build.query<GetMeasurementLogGetAllApiResponse, GetMeasurementLogGetAllApiArg>({
        query: () => ({ url: `/MeasurementLog/get-all` }),
        providesTags: ['MeasurementLog'],
      }),
      postMeasurementLogGetSelected: build.mutation<
        PostMeasurementLogGetSelectedApiResponse,
        PostMeasurementLogGetSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementLog/get-selected`,
          method: 'POST',
          body: queryArg.body,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            aggregationIntervalId: queryArg.aggregationIntervalId,
            tsoId: queryArg.tsoId,
          },
        }),
        invalidatesTags: ['MeasurementLog'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementLogApi };
export type GetMeasurementLogByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementLogExternalDto;
export type GetMeasurementLogByIdApiArg = number;
export type GetMeasurementLogGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementLogExternalDto;
export type GetMeasurementLogGetAllApiArg = void;
export type PostMeasurementLogGetSelectedApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementLogExternalDto;
export type PostMeasurementLogGetSelectedApiArg = {
  start?: string;
  end?: string;
  aggregationIntervalId?: number;
  tsoId?: number;
  body: string[];
};
export type ApiCommonExternalDtoMeasurementLogExternalDto = {
  id?: number;
  tsoId?: number;
  start: string;
  end: string;
  measurementDeviceId: number;
  aggregationIntervalId: number;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementLogExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementLogExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementLogExternalDto[] | null;
};
export const {
  useGetMeasurementLogByIdQuery,
  useLazyGetMeasurementLogByIdQuery,
  useGetMeasurementLogGetAllQuery,
  useLazyGetMeasurementLogGetAllQuery,
  usePostMeasurementLogGetSelectedMutation,
} = injectedRtkApi;
